export default {
    ACCESS_LEVEL_FULL: 100,
    ACCESS_LEVEL_DEMO: 10,
    ACCESS_LEVEL_FORBIDDEN: 0
}
